import BookSlotModal from './BookSlotModal';

export default BookSlotModal;
